import { render, staticRenderFns } from "./managedInstructionAssignmentMembers.vue?vue&type=template&id=6648c7b8"
import script from "./managedInstructionAssignmentMembers.vue?vue&type=script&lang=js"
export * from "./managedInstructionAssignmentMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports